import SettingsModule, {SettingsMenuTopCategory} from "../../../../core/modules/settings-module";
import {SettingsParentSection} from "../../const";

export default class SettingsDataArrivesQueue extends SettingsModule {

    constructor() {
        super({
            name                     : "Data arrives queue",
            description              : "",
            svgIcon                  : "isvg-logs",
            typeLabel                : "Organization account",
            settingsUrl              : "settings/date-arrives-queue",
            settingsMenuTopCategory  : SettingsMenuTopCategory.ORGANIZATION
        });

        this.parentSection          = SettingsParentSection.SYSTEM

        this.canDisable             = false
        this.hasStatus              = false
    }

}
